<template>
    <div class="coupon">
        <div>
            <div>
                <div class="coupon-discount">
                    <svg width="32px" height="30px" viewBox="0 0 20 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g transform="translate(-993.000000, -1482.000000)">
                            <g transform="translate(690.000000, 1460.000000)">
                                <g transform="translate(303.000000, 11.000000)">
                                    <polygon points="13.0901486 17.2614954 20 18.2654015 15.0001538 23.1391443 16.1799895 30.0213146 9.99969243 26.7721527 3.81939532 30.0213146 4.99984622 23.1391443 0 18.2654015 6.90985144 17.2614954 9.99969243 11"></polygon>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span v-if="coupon.value_type === 'percent'">{{ parseInt(coupon.value) }}<small>%</small></span>
                    <span v-else>{{ coupon.value | currency }}</span>
                    <svg width="32px" height="30px" viewBox="0 0 20 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g transform="translate(-993.000000, -1482.000000)">
                            <g transform="translate(690.000000, 1460.000000)">
                                <g transform="translate(303.000000, 11.000000)">
                                    <polygon points="13.0901486 17.2614954 20 18.2654015 15.0001538 23.1391443 16.1799895 30.0213146 9.99969243 26.7721527 3.81939532 30.0213146 4.99984622 23.1391443 0 18.2654015 6.90985144 17.2614954 9.99969243 11"></polygon>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="coupon-decor">
                    <svg width="52px" height="13px" viewBox="0 0 52 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g transform="translate(-954.000000, -1524.000000)">
                            <g transform="translate(690.000000, 1460.000000)">
                                <g transform="translate(264.000000, 55.000000)">
                                    <g transform="translate(0.000000, 9.000000)">
                                        <path d="M50.798,1.517 L13.623,1.517 C13.206,1.517 12.864,1.175 12.864,0.758 C12.864,0.341 13.206,0 13.623,0 L50.798,0 C51.216,0 51.557,0.341 51.557,0.758 C51.557,1.175 51.216,1.517 50.798,1.517"></path>
                                        <path d="M50.883,6.914 L0.673,6.914 C0.303,6.914 0,6.611 0,6.24 C0,5.87 0.303,5.567 0.673,5.567 L50.883,5.567 C51.254,5.567 51.557,5.87 51.557,6.24 C51.557,6.611 51.254,6.914 50.883,6.914"></path>
                                        <path d="M50.798,12.691 L13.623,12.691 C13.206,12.691 12.864,12.349 12.864,11.932 C12.864,11.515 13.206,11.173 13.623,11.173 L50.798,11.173 C51.216,11.173 51.557,11.515 51.557,11.932 C51.557,12.349 51.216,12.691 50.798,12.691"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span>
                        {{ $t('coupon') }}
                    </span>
                    <svg width="52px" height="14px" viewBox="0 0 52 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g transform="translate(-1107.000000, -1523.000000)">
                            <g transform="translate(690.000000, 1460.000000)">
                                <g transform="translate(264.000000, 55.000000)">
                                    <g transform="translate(153.000000, 8.788000)">
                                        <path d="M0.758,11.173 L37.933,11.173 C38.351,11.173 38.692,11.515 38.692,11.932 C38.692,12.349 38.351,12.691 37.933,12.691 L0.758,12.691 C0.341,12.691 0,12.349 0,11.932 C0,11.515 0.341,11.173 0.758,11.173"></path>
                                        <path d="M0.673,5.776 L50.883,5.776 C51.255,5.776 51.557,6.079 51.557,6.45 C51.557,6.82 51.255,7.124 50.883,7.124 L0.673,7.124 C0.302,7.124 0,6.82 0,6.45 C0,6.079 0.302,5.776 0.673,5.776"></path>
                                        <path d="M0.758,0 L37.933,0 C38.351,0 38.692,0.341 38.692,0.758 C38.692,1.175 38.351,1.517 37.933,1.517 L0.758,1.517 C0.341,1.517 0,1.175 0,0.758 C0,0.341 0.341,0 0.758,0"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
        </div>
        <div>
            <div class="coupon-code" v-html="$t('your_coupon_code_c', {code: coupon.code})"></div>
            <div class="coupon-countdown">
                <countdown :time="getCouponTime(coupon.valid_to)">
                    <template slot-scope="props">
                        <ul class="coupon-countdown-items">
                            <li>{{ props.days }}<small>{{ $t('countdown.day') }}</small></li>
                            <li>{{ props.hours }}<small>{{ $t('countdown.hour') }}</small></li>
                            <li>{{ props.minutes }}<small>{{ $t('countdown.minute') }}</small></li>
                            <li>{{ props.seconds }}<small>{{ $t('countdown.second') }}</small></li>
                        </ul>
                    </template>
                </countdown>
                <div class="coupon-countdown-date" v-html="$t('valid_until_d_full', {date: getCouponDate(coupon.valid_to)})"></div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../scss/variables";

    .coupon {
        position: relative;
        display: flex;
        align-items: center;
        line-height: 1;
        margin-top: 40px;
        padding: 8px 0;
        background-color: var(--coupon-banner-bg);

        &::before,
        &::after {
            position: absolute;
            content: '';
            top: 0;
            width: 15px;
            height: 100%;
            mask: url('../assets/coupon-side.svg') repeat-y;
            mask-size: 15px auto;
            background-color: var(--coupon-banner-bg);
        }

        &::before {
            right: 100%;
        }

        &::after {
            left: 100%;
            transform: scaleX(-1);
        }

        > div {
            display: flex;
            justify-content: center;
            flex-direction: column;
            padding: 10px 24px;
            height: 100%;

            &:first-child {
                align-items: center;
                border-right: 2px dashed var(--coupon-banner-bg-dark);

                > div {
                    position: relative;
                    padding: 18px 0;

                    &::before,
                    &::after {
                        position: absolute;
                        content: '';
                        width: 100%;
                        height: 9px;
                        left: 0;
                        mask: url('../assets/coupon-stars.svg') repeat-x;
                        background-color: var(--coupon-text-color);
                    }

                    &::before {
                        top: 0;
                    }

                    &::after {
                        bottom: 0;
                    }
                }
            }

            &:last-child {

            }
        }

        &-discount {
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--coupon-primary-color);
            line-height: 1;

            > svg {
                fill: var(--coupon-primary-color);
            }

            > span {
                display: block;
                max-width: 225px;
                margin: 0 20px;
                font-size: 3.6rem;
                white-space: nowrap;
                overflow: hidden;

                &,
                > small {
                    font-weight: bold;
                }

                > small {
                    font-size: 3rem;
                }
            }
        }

        &-decor {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 2px;
            font-size: 1.7rem;
            font-weight: lighter;
            text-transform: uppercase;

            > svg {
                fill: var(--coupon-text-color);
            }

            > span {
                display: block;
                margin: 0 9px;
                color: var(--coupon-text-color);
            }
        }

        &-code {
            padding: 16px;
            font-size: .75rem;
            color: var(--coupon-text-color);
            white-space: nowrap;
            background-color: var(--coupon-bg);

            > span {
                font-size: 1.87rem;
                font-family: 'Inconsolata', monospace;
            }
        }

        &-countdown {
            display: flex;
            align-items: center;
            margin-top: 20px;

            &-items {
                display: flex;
                align-items: flex-start;
                margin: 0 10px 0 0;
                padding: 0;
                list-style: none;

                > li {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    width: 35px;
                    height: 41px;
                    margin-right: 2px;
                    font-size: 1.1rem;
                    color: var(--coupon-bg);
                    line-height: 1;
                    background-color: var(--coupon-primary-color);

                    &:last-child {
                        margin-right: 0;
                    }

                    > small {
                        margin-top: 2px;
                        font-size: .62rem;
                        text-transform: lowercase;
                    }
                }
            }

            &-date {
                color: var(--coupon-text-color);
                font-size: .87rem;

                > span {
                    font-family: 'Inconsolata', monospace;
                }
            }
        }
    }

    body.-is-mobile {

        .coupon {
            width: calc(100% - 20px);
            margin-left: auto;
            margin-right: auto;
            flex-direction: column;

            > div:first-child {
                border-right: none;
                border-bottom: 2px dashed var(--coupon-banner-bg-dark);
            }
        }
    }
</style>

<script>
  import coupon from 'src/mixins/couponComponent';

  export default {
    mixins: [coupon],
  };
</script>
